export default "__VITE_ASSET__e862fea3__"